import { Schema as S } from "effect";

const InsuranceStatusSchema = S.Struct({
  insuranceNo: S.optional(S.String),
  insuranceId: S.optional(S.String),
  insuranceName: S.optional(S.String),
  insurancePrintName: S.optional(S.String),
  insuranceGrpId: S.optional(S.String),
  type: S.optional(S.String),
  billingFactor: S.optional(S.String),
  kv: S.optional(S.String),
  locationId: S.optional(S.String),
  _id: S.optional(S.String),
  cardSwipe: S.optional(S.NullOr(S.String)),
  address2: S.optional(S.String),
  address1: S.optional(S.String),
  bgNumber: S.optional(S.String),
  unzkv: S.optional(S.Array(S.Unknown)),
  fused: S.optional(S.Boolean),
  feeSchedule: S.optional(S.String),
  costCarrierBillingGroup: S.optional(S.String),
  costCarrierBillingSection: S.optional(S.String),
  dmp: S.optional(S.String),
  persGroup: S.optional(S.String),
  insuranceKind: S.optional(S.String),
  fk4110: S.optional(S.NullOr(S.String)),
  fk4133: S.optional(S.NullOr(S.String)),
});

const AddressSchema = S.Struct({
  kind: S.String,
  _id: S.optional(S.String),
  addon: S.optional(S.String),
  countryCode: S.optional(S.String),
  country: S.optional(S.String),
  city: S.optional(S.String),
  zip: S.optional(S.String),
  houseno: S.optional(S.String),
  street: S.optional(S.String),
  receiver: S.optional(S.String),
});

const CommunicationSchema = S.Struct({
  type: S.String,
  value: S.String,
  _id: S.optional(S.String),
});

const PatientSchema = S.Struct({
  _id: S.String,
  patientNo: S.optional(S.NullOr(S.String)),
  patientNumber: S.optional(S.Number),
  countryMode: S.optional(S.Array(S.String)),
  kbvDob: S.optional(S.String),
  careDegree: S.optional(S.String),
  dob: S.optional(S.String),
  gender: S.optional(S.String),
  talk: S.optional(S.String),
  dataTransmissionToPVSApproved: S.optional(S.Boolean),
  markers: S.optional(S.Array(S.Unknown)),
  physicians: S.optional(S.Array(S.String)),
  institution: S.optional(S.String),
  edmpTypes: S.optional(S.Array(S.Unknown)),
  insuranceStatus: S.optional(S.Array(InsuranceStatusSchema)),
  addresses: S.optional(S.Array(AddressSchema)),
  communications: S.optional(S.Array(CommunicationSchema)),
  partnerIds: S.optional(
    S.Array(
      S.Struct({
        _id: S.optional(S.String),
        patientId: S.optional(S.String),
        partnerId: S.optional(S.String),
      }),
    ),
  ),
  lastname: S.optional(S.String),
  fk3120: S.optional(S.String),
  middlename: S.optional(S.String),
  nameaffix: S.optional(S.String),
  firstname: S.optional(S.String),
  title: S.optional(S.String),
  patientStatus: S.optional(S.Array(S.String)),
  hzvContractsPatientDetails: S.optional(S.Array(S.Unknown)),
});

export const FindPatientResponseSchema = S.Array(PatientSchema);

export type FindPatientResponse = S.Schema.Type<typeof FindPatientResponseSchema>;
